const shippingProviders = t => [
    {
        text: t('shippingProviders_schenkerPrivpak'),
        type: 'SchenkerPrivpak',
        logoImgUrl: '/static/images/shipping/schenker.svg'
    },
    {
        text: t('shippingProviders_posten'),
        type: 'Posten',
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_postNordParcel'),
        type: 'PostNordParcel',
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_postNordStamp'),
        type: 'PostNordStamp',
        logoImgUrl: '/static/images/shipping/postnord.svg'
    },
    {
        text: t('shippingProviders_dhl'),
        type: 'DHL',
        logoImgUrl: '/static/images/shipping/dhl.svg'
    },
    {
        text: t('shippingProviders_bussgods'),
        type: 'Bussgods',
        logoImgUrl: '/static/images/shipping/bussgods.svg'
    },
    {
        text: t('shippingProviders_alternative'),
        type: 'Alternative',
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_takeaway'),
        type: 'Takeaway',
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_takeaway'),
        type: 'TakeawayOnly',
        logoImgUrl: null
    },
    {
        text: t('shippingProviders_notSpecified_full'),
        type: 'NotSpecified',
        logoImgUrl: null
    }
];

export default {
    get: t => shippingProviders(t)
};
